<template>
  <div
    id="examSystem"
    :style="{ 'padding-top': !showPage ? '100vh' : '0' + 'px' }"
    v-loading="!showPage"
    element-loading-text="加载中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <router-view v-if="showPage" />
  </div>
</template>

<script>
import { toClientData } from "@/utils/format";
export default {
  name: "app",
  data() {
    return {
      showPage: false,
    };
  },
  created() {
    this.setLanguage();
    this.reSetRoleName();
  },
  methods: {
    // 是否重新设置角色
    reSetRoleName() {
      const roleName = sessionStorage.getItem("refreshRoleName");
      if (!roleName) {
        this.$store.commit("user/setRoleName", ["stu"]);
        sessionStorage.setItem("refreshRoleName", true);
      }
    },
    // 获取后台语言包
    async getLanguagePack() {
      try {
        let data_zh = await this.$store.dispatch("user/getLanguagePack", {
          lang: "zh_cn",
        });
        let data_en = await this.$store.dispatch("user/getLanguagePack", {
          lang: "en",
        });
        // 后台数据格式转换
        data_zh = toClientData(data_zh);
        data_en = toClientData(data_en);
        console.log("data_zh", data_zh);
        console.log("data_en", data_en);
        return {
          zh_cn: data_zh,
          en: data_en,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async setLanguage() {
      let enPack = sessionStorage.getItem("en");
      let zhPack = sessionStorage.getItem("zh_cn");

      if (enPack && zhPack) {
        this.$i18n.setLocaleMessage("en", JSON.parse(enPack));
        this.$i18n.setLocaleMessage("zh_cn", JSON.parse(zhPack));
        this.showPage = true;
      } else {
        const { en, zh_cn } = await this.getLanguagePack();
        sessionStorage.setItem("en", JSON.stringify(en));
        sessionStorage.setItem("zh_cn", JSON.stringify(zh_cn));

        this.$i18n.setLocaleMessage("en", en);
        this.$i18n.setLocaleMessage("zh_cn", zh_cn);
        this.showPage = true;
      }
    },
  },
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
